// icici-axios.js
//
// Dedicated axios instance for the ICICI Eazypay calls. Kept separate from
// ../../../axios-url.js (which points at the real HRMS/POS backend) for the
// same reason razorpay-axios.js is — these routes don't exist there yet.
// This points at the local .NET service (c:\work\IciciPg) standing in for
// them, which exposes:
//
//   GET  /health
//   POST /api/icici/qr                 -> { success, merchantRef, upiQr, ... }
//   GET  /api/icici/payments/{ref}     -> { state, isPaid, txnId, ... }
//   POST /api/icici/payments/{ref}/cancel
//
// Once the real backend adds equivalent routes, swap this baseURL (or drop
// this file and use the shared axios-url.js instance instead).
import axios from 'axios';

const iciciAxios = axios.create({
    baseURL: 'https://localhost:5081',
    headers: {
        'Content-Type': 'application/json',
    },
});

export default iciciAxios;
